module.exports = __webpack_public_path__ + "static/reg-large5-02ddd72a9bc65d610f7c3aef113b1c34.jpg";